import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import soraOriginalImage from '../../../assets/sora_original_image.png';
import soraImageVideo from '../../../assets/video/sora_image_generate_video.mp4';
import soraTextVideo from '../../../assets/video/sora_text_gererate_video.mp4';
import './Examples.scss';

export default function Examples() {
  const { t } = useI18n();
  return (
    <section className="sora2-examples">
      <div className="sora2-examples__inner">
        <h2>{t('videoGeneration.sora.examples.title')}</h2>
        <p className="sora2-examples__sub">{t('videoGeneration.sora.examples.sub')}</p>

        <div className="sora2-block">
          <h3>{t('videoGeneration.sora.examples.imageToVideo')}</h3>
          <p className="sora2-block__desc">{t('videoGeneration.sora.examples.imageToVideoDesc')}</p>
          <div className="sora2-block__grid two">
            <div className="sora2-card tall">
              <div className="sora2-card__header">
                <span className="sora2-card__dot" />
                {t('videoGeneration.sora.examples.originalImage')}
              </div>
              <div className="sora2-card__media">
                <img src={soraOriginalImage} alt="original" className="sora2-card__img" />
              </div>
            </div>
            <div className="sora2-card tall glow">
              <div className="sora2-card__header">
                <span className="sora2-card__dot" />
                {t('videoGeneration.sora.examples.generatedVideo')}
                <span className="sora2-card__pill">{t('videoGeneration.sora.examples.pill')}</span>
              </div>
              <div className="sora2-card__media">
                <video className="sora2-card__video" src={soraImageVideo} controls muted playsInline preload="metadata" poster={soraOriginalImage} />
                <div className="sora2-card__bar"><span className="time">0:00 / 0:04</span><span className="quality">Generated by Sora 2</span></div>
              </div>
            </div>
          </div>
        </div>

        <div className="sora2-block">
          <div className="sora2-block__grid prompt">
            <div className="sora2-card wide glow">
              <div className="sora2-card__header">
                <span className="sora2-card__dot" />
                {t('videoGeneration.sora.examples.generatedVideo')}
                <span className="sora2-card__pill">{t('videoGeneration.sora.examples.pill')}</span>
              </div>
              <div className="sora2-card__media">
                <video className="sora2-card__video" src={soraTextVideo} controls muted playsInline preload="metadata" />
                <div className="sora2-card__bar"><span className="time">0:00 / 0:04</span><span className="quality">Generated by Sora 2</span></div>
              </div>
            </div>
            <div>
              <h3 className="sora2-right__title">{t('videoGeneration.sora.examples.textToVideo')}</h3>
              <p className="sora2-right__sub">{t('videoGeneration.sora.examples.textToVideoDesc')}</p>
              <div className="sora2-prompt">
                <div className="sora2-prompt__title"><span className="dot" />{t('videoGeneration.sora.examples.promptLabel')}</div>
                <div className="sora2-prompt__body">{t('videoGeneration.sora.examples.promptText')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}